let baseUrl = 'https://btvplus.mn';
// let baseUrl = 'http://bloomberg-backend.test';

export default {
    HOST: baseUrl,
    IMG_HOST: baseUrl,
};
